<template>
  <div >
    <p><span v-if="session.title">Session {{session.title}}</span></p>
<ul class="collapsible tasks" ref="collapsible">
  <li v-for="(task, index) in sortedTasks" :key="index">
    
    <div class="collapsible-header">
      <i class="material-icons">{{task.type | iconifyTask }}</i><span v-html="renderTitle(task.title)"/> <i v-if="task.recordSkill" class="material-icons red-text text-accent-2 icon-tiny">flag</i>
      <span v-if="task.capTime" class="new badge" data-badge-caption="">{{getTaskDuration(task)}}'</span>     
    </div>
    <div class="collapsible-body">
      <div class="row">
        <div class="col s12">
          <span>
            <span v-html="renderInstruction(task.instruction)" class="instruction browser-default" />
            <InputRecord v-if="task.recordSkill" :record="task.recordSkill" :isReadOnly="isPastSession" />
          </span>
        </div>
      </div>

    </div>
  </li>
</ul>

<div class="row">
  <div class="col s4 left-align"> 
    <router-link v-if="isPastSession" class="waves-effect waves-light btn grey left" :to="{ name: 'Sessions', query: {tab: 'past'} }">Back
    </router-link>
    <router-link v-else class="btn grey " :to="{ name: 'Sessions' }">Back
    </router-link>
  </div>
  <div class="col s4 left-align" v-if="!isPastSession">
    <a class="btn red modal-trigger" href="#modalDismiss">Missed
    </a>
      <!-- Modal Structure -->
      <div  ref="dismissModal" id="modalDismiss" class="modal">
        <div class="modal-content">
          <h4>Dismiss the session</h4>
          <p>Do you confirm you want to DISCARD this session?</p>
        </div>
        <div class="modal-footer">
          <a href="#!" class="modal-close waves-effect waves-green btn-flat">No</a>
          <a href="#!" class="modal-close waves-effect waves-green btn-flat" v-on:click="dismiss()">Yes, Dismiss</a>
        </div>
      </div>
  </div>
  <div class="col s4 right-align" v-if="!isPastSession">
    <button class="waves-effect waves-light btn green " v-on:click="complete()">Done
    </button>
  </div>
</div>
</div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import DoT from 'dot'
import moment from 'moment'
import marked from 'marked'
import DOMPurify from 'dompurify'
import InputRecord from '@/components/records/InputRecord'
export default {
  name: 'session',
  props: {
    isPastSession: Boolean,
    session: Object,
    user: Object
  },
  components: { InputRecord },
  data: function () {
    return {
      tasks: []
    }
  },
  created () {
    this.tasks = this.session.tasks
    if (!this.isPastSession) {
      // Collect the skills to record
      const skills = api.getSkills()
      for (var i in this.tasks) {
        if (this.tasks[i].withRecord) {
          var skillName = this.tasks[i].withRecord
          var skill = skills[skillName]
          // Get exiting record value
          if (skill) {
            var record = this.user.athlete.records[skillName]
            if (record) {
              if (record.unit === 'time') {
                skill.valueMinutes = record.valueMinutes
                skill.valueSeconds = record.valueSeconds
              } else {
                skill.value = record.value
              }
            }
            skill.skill = skillName
            this.tasks[i].recordSkill = skill
          } else {
            throw new Error('Use of undefined ' + skillName)
          }
        }
      }
    }
  },
  mounted () {
    M.Collapsible.init(this.$refs.collapsible, {})
    M.Modal.init(this.$refs.dismissModal, {})
  },
  methods: {
    complete: function () {
      // add new records to the athlete
      for (var i in this.tasks) {
        var task = this.tasks[i]
        if (task.recordSkill) {
          // if a value is set
          if (task.recordSkill.value || task.recordSkill.valueMinutes || task.recordSkill.valueSeconds) {
            this.user.addRecord(task.recordSkill)
          }
        }
      }
      // Change the status of the session to completed
      this.session.dt = moment()
      this.session.status = 'Completed'
      this.user.athlete.nextSessions[this.session.id] = this.session
      api.addPastSession(this.user, this.session)
      api.update(this.user)
      this.$router.push({ name: 'Sessions' })
    },
    dismiss: function () {
      this.session.dt = moment()
      this.session.status = 'Missed'
      delete this.user.athlete.nextSessions[this.session.id] // remove the session from the list
      api.addPastSession(this.user, this.session)
      api.update(this.user)
      this.$router.push({ name: 'Sessions' })
    },
    renderInstruction: function (tpl) {
      var htmlTpl = DOMPurify.sanitize(marked(tpl))
      var fRender = DoT.template(htmlTpl)
      var dTpl = fRender(this.user)
      return dTpl
    },
    renderTitle: function (tpl) {
      var fRender = DoT.template(tpl)
      return fRender(this.user)
    },
    hasTimer: function (task) {
      return Number.isNaN(parseInt(task.capTime))
    },
    getTimer: function (task) {
      const args = task.capTime.split('-')
      switch (args[0]) {
        case 'countdown':
          return {mode: args[0], options: {delay: parseInt(args[1])}}
        case 'clock':
          return {mode: args[0], options: {cap: parseInt(args[1])}}
        case 'EMOM':
          return {mode: args[0], options: {roundDuration: parseInt(args[1]) * 60, rounds: parseInt(args[2])}}
      }
    },
    getTaskDuration: function (task) {
      if (task.capTime) {
        if (this.hasTimer(task)) {
          const timer = this.getTimer(task)
          switch (timer.mode) {
            case 'clock':
              return timer.options.cap
            case 'countdown':
              return timer.options.delay
            case 'EMOM':
              return timer.options.rounds * timer.options.roundDuration / 60
            default:
              return task.capTime
          }
        } else {
          return task.capTime
        }
      } else {
        return undefined
      }
    }
  },
  computed: {
    sortedTasks () {
      return this.tasks.sort((a, b) => a.index - b.index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
span.badge.flag {
    font-weight: 300;
    font-size: 0.8rem;
    color: #26a69a;
    border-radius: 2px;
}
.icon-tiny {
  font-size: 3px;
}
.instruction {
 list-style-type: circle;
}
</style>


// WEBPACK FOOTER //
// src/components/sessions/Session.vue